<div class="insurer-card" [ngClass]="first ? 'highlight' : ''">
  @switch (isVehicleTypeAccess) {
    @default {
      @if (
        requestData.dealerType !== 'POLICYSTREET' &&
        requestData.dealerType !== 'CARSOMEDR'
        ) {
        <div
          >
          @if (first && translate.currentLang === 'en') {
            <img
              class="cheapest-tag"
              src="https://storage.googleapis.com/dev-ps-asset/affiliate/logo/Tag.png"
              alt=""
              />
          }
          @if (first && translate.currentLang !== 'en') {
            <img
              class="cheapest-tag"
              src="https://storage.googleapis.com/dev-ps-asset/affiliate/logo/Tag-bm.png"
              alt=""
              />
          }
        </div>
      }
      @if (
        requestData.dealerType == 'POLICYSTREET' ||
        requestData.dealerType == 'CARSOMEDR'
        ) {
        <div
          >
          @if (showTag) {
            <img
              [src]="getRibbonType(item?.code)"
              class="grab-ribbon"
              />
          }
        </div>
      }
    }
    @case ('Motorcycle') {
      @if (item.requestType == 'MotorcycleTPRequest') {
        <img
          class="insurance-type-tag"
				[src]="
					'https://storage.googleapis.com/dev-ps-asset/motorcycle/shared/TP-tag-' +
					translate.currentLang +
					'.png'
				"
          />
      }
      @if (item.requestType !== 'MotorcycleTPRequest') {
        <img
          class="insurance-type-tag"
				[src]="
					'https://storage.googleapis.com/dev-ps-asset/motorcycle/shared/COM-tag-' +
					translate.currentLang +
					'.png'
				"
          />
      }
    }
  }

  <div class="insurer-card__header" [ngClass]="first ? 'highlight' : ''">
    <div class="insurer-card__header__logo">
      <img [src]="item?.image" />
    </div>

    <div class="insurer-card__header__pricing">
      <!-- Total Price -->
      <div class="pricing-total">
        <span>RM</span>
        <span class="price-value">{{
          totalCharges | number : "1.2-2"
        }}</span>
      </div>

      <!-- Sum Insured Section -->
      <div class="sum-insured-with-badge">
        <!-- Badge if present -->
        @if (item?.sumInsuredRange === 'Highest') {
          <span
            class="sum-insured__badge_Highest"
            >
            {{ "common.Highest" | translate }}
          </span>
        }
        @if (item?.sumInsuredRange === 'Lowest') {
          <span
            class="sum-insured__badge_Lowest"
            >
            {{ "common.Lowest" | translate }}
          </span>
        }

        <!-- Sum Insured Text -->
        <div class="sum-insured">
          <p>
            {{ getSILabelName | translate }} ({{
            "common." + item?.typeOfSum | translate
            }}):
          </p>
          <p>RM {{ item.sumInsured | number : "1.2-2" }}</p>
        </div>
      </div>

      <!-- Sum Insured Range Indicator -->
      @if (item.typeOfSum === 'AV' && item.minAVSI > 0) {
        <div
          class="sum-insured-range"
          >
          <div>Min AV - Max AV</div>
          <div>
            {{
            "common.minMaxRangeValue"
            | translate
            : {
            currency: "RM",
            min: item?.minAVSI | number : "1.2-2",
            max: item?.maxAVSI | number : "1.2-2"
          }
          }}
        </div>
      </div>
    }
  </div>
</div>

<div class="insurer-card__content">
  <div class="insurer-card__content__benefit">
    <div class="insurer-card__content__benefit__flex">
      <div class="insurer-card__content__benefit__title">
        {{ "common.benefits" | translate | titlecase }}
      </div>
      <div class="insurer-card__content__benefit__note">
        {{ getPolicyLabelName | translate }}
      </div>
    </div>

    <ul>
      @for (benefit of benefits; track benefit) {
        @if (
          hasTranslation(benefit.description) && benefit.type == 'driver'
          ) {
          <li
            >
            <img src="assets/image/protection-drivers.svg" />
            <span>
              {{ "comparison.protectionDriver" | translate }}:
              <b class="color-dark-green">
                {{ benefit.description | translate }}
              </b>
            </span>
          </li>
        }
        @if (
          hasTranslation(benefit.description) &&
          benefit.type === 'allRiders'
          ) {
          <li
            >
            <img
              style="min-width: 24px !important"
              src="assets/image/two-wheeler.png"
              />
              <span>
                {{ "insurerDetails.allRiders" | translate }}
                <b class="color-dark-green">
                  {{ benefit.description | translate }}
                </b>
              </span>
            </li>
          }
          @if (
            hasTranslation(benefit.description) && benefit.type == 'towing'
            ) {
            <li
              >
              <img src="assets/image/towing-service.svg" />
              <span>
                {{ "insurerDetails.towingService" | translate }}
                <b class="color-dark-green">
                  {{ benefit.description | translate }}
                </b>
              </span>
            </li>
          }
          @if (
            hasTranslation(benefit.description) &&
            benefit.type == '24hrTowing'
            ) {
            <li
              >
              <img src="assets/image/towing-service.svg" />
              <span>
                {{ "insurerDetails.24hrTowingService" | translate }}
                <b class="color-dark-green">
                  {{ benefit.description | translate }}
                </b>
              </span>
            </li>
          }
          @if (
            hasTranslation(benefit.description) &&
            benefit.type == 'unlimitedTowing'
            ) {
            <li
              >
              <img src="assets/image/towing-service.svg" />
              <span>
                {{ "insurerDetails.unlimitedTowingService" | translate }}
              </span>
            </li>
          }
          @if (
            hasTranslation(benefit.description) && benefit.type == 'free'
            ) {
            <li
              class="benefit-item"
              >
              <div class="benefit-row">
                <mat-icon class="benefit-icon color-dark-green"
                  >check_circle</mat-icon
                  >
                  <span class="benefit-text">
                    <b class="color-dark-green">{{
                      "benefits.free" | translate
                    }}</b>
                    {{ benefit.description | translate }}
                  </span>
                </div>
              </li>
            }
            @if (
              hasTranslation(benefit.description) && benefit.type == 'included'
              ) {
              <li
                >
                <mat-icon class="color-dark-green">check_circle</mat-icon>
                <span
                  ><b class="color-dark-green">{{ "benefits.included" | translate }}</b>
                  {{ benefit.description | translate }}</span
                  >
                </li>
              }
              @if (hasTranslation(benefit.description) && benefit.type == '') {
                <li
                  class="benefit-item"
                  >
                  <div class="benefit-row">
                    <div>
                      <img src="assets/image/thumb_up.svg" />
                    </div>
                    <span class="benefit-text">{{
                      benefit.description | translate
                    }}</span>
                  </div>
                </li>
              }
              @if (
                hasTranslation(benefit.description) &&
                benefit.type == 'sectionTitle'
                ) {
                <li
                  >
                  <span>{{ benefit.description | translate }}</span>
                </li>
              }
            }
          </ul>

          @if (totalBenefits > 4) {
            <button
              class="insurer-card__content__benefit__link mb-sm"
              (click)="toggleMoreBenefits()"
              >
              {{
              showMoreBenefits
              ? ("common.seeLess" | translate)
              : ("common.seeAll" | translate) +
              " " +
              totalBenefits +
              " " +
              ("common.benefits" | translate)
              }}
              ...
            </button>
          }
        </div>
        <mat-divider></mat-divider>

        <div class="insurer-card__content__footer">
          <!-- <div
          class="insurer-installment"
          *ngIf="requestData.isOnlinePayment"
          >
          {{ "common.pay" | translate }}
          <b>RM{{ item.total / 3 | number : "1.2-2" }}</b>
          {{ "common.everyMonth" | translate }} <br />{{
          "common.duration" | translate
          }}!
        </div> -->
        <button
          mat-flat-button
          class="insurer-card__content__footer__btn"
          (click)="handleBuyNow()"
          >
          {{ "comparison.buyNow" | translate }}
        </button>
        <div class="">
          @if (eppEligibility && eppEligibility.isEligible) {
            <div
              class="instalment-note"
              >
              {{ "common.pay" | translate }}
              <b
                >RM{{
                totalBasePremiumAfterRebate / eppEligibility.months
                | number : "1.2-2"
                }}</b
                >
                <span> {{ "common.everyMonth" | translate }}</span>
                <span>
                  {{
                  eppEligibility.months == 6
                  ? ("common.duration6" | translate)
                  : ("common.duration12" | translate)
                  }}
                  <br
                  /></span>
                  <span class="instalment-note--sm">
                    {{ "common.epp" | translate }}
                  </span>
                </div>
              }
              @if (item?.rebate) {
                <div class="rebate-note">
                  <img src="assets/image/rebate-crown-icon.png" />
                  {{ "common.includedRebate" | translate }}
                  <b>RM{{ item?.rebate | number : "1.2-2" }}</b>
                </div>
              }
            </div>

            @if (documents?.length) {
              <mat-divider></mat-divider>
              <div class="insurer-card__content__footer__documents">
                @for (doc of documents; track doc; let i = $index; let last = $last) {
                  <a
                    class="insurer-card__content__footer__link"
                    [href]="doc.url"
                    target="_blank"
                    >
                    <mat-icon>open_in_new</mat-icon>
                    <span>{{ doc.name }}</span>
                  </a>
                  @if (!last) {
                    <span class="document-divider">|</span>
                  }
                }
              </div>
            }
          </div>
        </div>
      </div>
